import { Yii } from "libraries/interfaces/Yii";

export class VatConfigurationWording {
    public readonly vatRate: string = Yii.t('wui-watabi-js', 'TVA à appliquer');
    public readonly vatDisplayMode: string = Yii.t('wui-watabi-js', "Mode d'affichage");
    public readonly excludedTax: string = Yii.t('wui-watabi-js', 'Hors Taxes');
    public readonly includedTax: string = Yii.t('wui-watabi-js', 'Toutes Taxes Comprises');
    public readonly displayModeHelp: string = Yii.t('wui-watabi-js', 'Détermine quels totaux seront affichés (par exemple pour faire vos prix arrondis sur les prix TTC ou HT, et les présenter au client), ce choix peut être modifié à tout moment.');

}
